import * as moment from 'moment';
import axios from 'axios'
import { serverIp} from '../config/constants.js'

export function log(message) {
    console.log(message);
}

/**
 * SEND UPDATE ABOUT ORDER FOR NON MAIN STATUS
 */

export function udpateNonMainStatusOnServer(orderId, adminEmail, orderStatus) {

    axios.post(serverIp + 'orders/udpateNonMainStatus', {
        orderId: orderId,
        adminEmail: adminEmail,
        orderStatus: orderStatus,
    })
        .then((response) => {
            console.log("upex8:" + console.log(JSON.stringify(response.data, null, 3)));
        })
        .catch((error) => {
            console.log(error);
        });
}

/**
 * TRACK FB CLICKS
 */
export function TrackFbClicks(itemToTrack, campaign, admin, adset) {

    console.log("fbx21 ++++ TrackFbClicks itemToTrack:" + itemToTrack + "admin:" + admin + " campaign:" + campaign);

    let sentCampaign = campaign;
    if (campaign === undefined) {
        console.log("fbx12 campaigns is undefined");
        sentCampaign = 'unknown'
    }

    var eventProperties = {
        // 'selection': 'template',
        'fbId': itemToTrack,
        'campaign': sentCampaign,
        admin: admin, 
        'adset':adset
    }


}

export function GetDaysSinceOrderPlaced(dateOrderPlaceInMilli) {

    var a = moment(dateOrderPlaceInMilli);
    var b = moment();
    // var dayCount = a.diff(b, 'days');

    var dayCount = b.diff(a, 'days');

    return dayCount
}


// WEBPACK FOOTER //
// ./src/Utilities/Utils.js